/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { PureComponent } from 'react'

import { hasRedirectOnMount, redirectOnMount } from '@modules/auth/auth'

import AppLoadingRoot from '../../AppLoadingRoot'
import { buildSignInQuery } from '../../../lib/urlUtils'

import type { ReactElement } from 'react'
import type { AllProps as Props } from './types'

class AzureLogin extends PureComponent<Props> {
  componentDidMount(): void {
    const { loginWithAzure, queryString, redirectAfterLogin, redirectTo, newBearerToken } =
      this.props
    const query = buildSignInQuery({ search: queryString, withReferrer: true })

    if (hasRedirectOnMount(newBearerToken)) {
      redirectOnMount({ redirectAfterLogin, redirectTo, newBearerToken })
      return
    }

    loginWithAzure(query)
  }

  render(): ReactElement {
    return <AppLoadingRoot />
  }
}

export default AzureLogin
